export default {
	NOT: 'NOT',
	EQUAL: 'EQUAL',
	NOT_EQUAL: 'NOT_EQUAL',
	IS_EMPTY: 'IS_EMPTY',
	GREATER_THAN: 'GREATER_THAN',
	LESSER_THAN: 'LESSER_THAN',
	GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
	LESSER_THAN_OR_EQUAL: 'LESSER_THAN_OR_EQUAL',
	OR: 'OR',
	AND: 'AND',
	ADD: 'ADD',
	SUB: 'SUB',
	MUL: 'MUL',
	DIV: 'DIV',
	MOD: 'MOD',
	CONCAT: 'CONCAT',
	MATCH: 'MATCH',
	INCLUDES: 'INCLUDES',
	CONTAINS: 'CONTAINS',
	CONTAINS_ERROR: 'CONTAINS_ERROR',
	NOT_CONTAINS_ERROR: 'NOT_CONTAINS_ERROR',
	SIZE_EQUAL: 'SIZE_EQUAL',
	SIZE_NOT_EQUAL: 'SIZE_NOT_EQUAL',
	SIZE_GREATER_THAN: 'SIZE_GREATER_THAN',
	SIZE_GREATER_THAN_OR_EQUAL: 'SIZE_GREATER_THAN_OR_EQUAL',
	SIZE_LESSER_THAN: 'SIZE_LESSER_THAN',
	SIZE_LESSER_THAN_OR_EQUAL: 'SIZE_LESSER_THAN_OR_EQUAL'
};
